<div class="toolbar">
    <div class="portal-content">
        <ng-template [cdkPortalOutlet]="portal()" />
    </div>
    <div class="menu-button" [matMenuTriggerFor]="userMenu">
        <div class="btn-content">
            <span class="username">{{ username() }}</span>
            <span class="org-name">{{ orgName() }}</span>
        </div>

        <mat-icon>keyboard_arrow_down</mat-icon>
    </div>

    <mat-menu #userMenu="matMenu">
        <button i18n='@@app.navbar.logout' mat-menu-item (click)="logout.emit()">
            <mat-icon>logout</mat-icon>
            Logout
        </button>
    </mat-menu>
</div>
